import { Enumify } from 'enumify-ts';
import { GeographicAreaShape } from "./api/Representation";
export default class MapShapeSelectionOptions extends Enumify() {
    label;
    build;
    static CIRCLE = new MapShapeSelectionOptions("Circle", (key, title, colourHex, center) => {
        const circle = {
            key: key,
            title: title,
            priority: 5,
            shape: GeographicAreaShape.CIRCLE,
            center: center,
            colourHex: colourHex,
            radius: 5000
        };
        return circle;
    });
    static RECTANGLE = new MapShapeSelectionOptions("Rectangle / Square", (key, title, colourHex, center) => {
        const rect = {
            key: key,
            title: title,
            priority: 5,
            shape: GeographicAreaShape.RECTANGLE,
            center: center,
            colourHex: colourHex,
            bounds: {
                north: center.lat + 0.1,
                east: center.lng + 0.1,
                south: center.lat - 0.1,
                west: center.lng - 0.1
            }
        };
        return rect;
    });
    static POLYGON = new MapShapeSelectionOptions("Polygon", (key, title, colourHex, center) => {
        const rect = {
            key: key,
            title: title,
            priority: 5,
            shape: GeographicAreaShape.POLYGON,
            center: center,
            colourHex: colourHex,
            path: [{
                    lat: center.lat,
                    lng: center.lng - 0.1
                }, {
                    lat: center.lat + 0.1,
                    lng: center.lng + 0.1
                }, {
                    lat: center.lat - 0.1,
                    lng: center.lng + 0.1
                }]
        };
        return rect;
    });
    static _ = MapShapeSelectionOptions._closeEnum();
    constructor(label, build) {
        super();
        this.label = label;
        this.build = build;
    }
    static selectOptions() {
        return MapShapeSelectionOptions.values.map(t => {
            return { value: t.key, label: t.label };
        });
    }
}
